<template>
  <div>
    <v-col
      v-if="value !== undefined && value !== null"
    >
      <v-row>
        <v-col
          v-for="variable in variableKeys"
          :key="variable"
          class="pa-1 pb-0"
        >
          <v-progress-linear
            class="table-value-progress"
            :color="colors[variable]"
            height="40px"
            rounded
            :value="variable === 'WL_Underload' ? (value / stats[variable]) * 100 : ((value - stats[variableKeys[variableKeys.indexOf(variable) - 1]]) / (stats[variable] - stats[variableKeys[variableKeys.indexOf(variable) - 1]])) * 100"
          >
            <template
              v-slot:default
            >
              {{ $t(`load_zones.${variable.split('_')[1].toLowerCase()}`) }}
            </template>
            {{ stats[variable] }}
          </v-progress-linear>
        </v-col>
        <v-col
          class="pa-1 pb-0"
        >
          <v-progress-linear
            class="table-value-progress"
            color="#DD644C"
            height="40px"
            rounded
            :value="((value - stats['WL_Development'] ) / max) * 100"
          >
            <template
              v-slot:default
              class="text-center"
              style="height: 10px"
            >
              {{ $t('load_zones.overload') }}
            </template>
          </v-progress-linear>
        </v-col>
        <v-col cols="1">
          <strong> {{ value }} </strong>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="1"
        />
        <v-col
          v-for="variable in variableKeys"
          :key="variable"
          justify="center"
          align="center"
        >
          {{ stats[variable] }}
        </v-col>
        <v-col
          cols="1"
          offset="1"
        />
      </v-row>
    </v-col>
    <div
      v-else
      class="grey--text caption"
    >
      N/A
    </div>
  </div>
</template>

<script>

export default {
  name: 'WLProgressValue',
  props: {
    value: {
      type: [Number, String],
      default: undefined
    },
    max: {
      type: Number,
      default: 100
    },
    color: {
      type: String,
      default: 'grey'
    },
    stats: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    variableKeys: ['WL_Underload', 'WL_Taper', 'WL_Ordinary', 'WL_Development'],
    colors: {
      WL_Underload: '#008FFB', WL_Taper: '#F4A641', WL_Ordinary: '#F9E03B', WL_Development: '#86CC8E'
    }
  })
}
</script>
